<div class="inactive-account-banner" role="status">
  <mat-icon class="inactive-account-banner-icon">visibility</mat-icon>
  <span class="inactive-account-banner-text">
    {{ "inactiveAccountBanner.message" | translate: { accountName: accountName() } }}
  </span>
  <button mat-button class="inactive-account-banner-action" (click)="stopViewing()">
    {{ "inactiveAccountBanner.stop-viewing" | translate }}
  </button>
</div>
